if (!customElements.get('moth-product')) {
  customElements.define('moth-product', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const buttons = [...this.querySelectorAll('.moth-thumbs button')];
      const slides = [...this.querySelectorAll('.moth-slide')];
      buttons.forEach((button) => button.addEventListener('click', () => {
        slides.forEach((slide) => { slide.hidden = slide.id !== button.getAttribute('aria-controls'); });
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      }, { signal }));

      const purchase = this.querySelector('[data-moth-purchase]');
      if (purchase) {
        const df = purchase.querySelector('[data-ebu-acc-toggle]');
        const dfCard = purchase.querySelector('[data-ebu-acccard]');
        const updatePurchase = () => {
          const extra = df?.getAttribute('aria-checked') === 'true' ? Number(dfCard.dataset.ebuAccPrice) : 0;
          const total = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: purchase.dataset.currency }).format((Number(purchase.dataset.kitPrice) + extra) / 100);
          purchase.querySelector('[data-moth-total]').textContent = total;
          const items = `${purchase.dataset.kitId}:1${df?.getAttribute('aria-checked') === 'true' ? `,${dfCard.dataset.ebuAcc}:1` : ''}`;
          this.querySelectorAll('[data-moth-buy]').forEach(link => { link.href = `${purchase.dataset.cartRoot}${items}`; });
          const stickyBuy = document.querySelector('[data-sbb-root] a[class*="gotak-sbb-cta-"]');
          if (stickyBuy) stickyBuy.href = `${purchase.dataset.cartRoot}${items}`;
          window.dispatchEvent(new CustomEvent('gotak:variant-change', { detail: { totalText: total } }));
          const includeDf = df?.getAttribute('aria-checked') === 'true';
          const invoiceBody = `I'd like to pay by ACH for a MOTH complete kit${includeDf ? ' with the optional DF antenna' : ''}. Please send payment details.`;
          this.querySelectorAll('[data-moth-bank]').forEach(link => { link.href = `mailto:sales@getgotak.com?subject=${encodeURIComponent('MOTH ACH payment inquiry')}&body=${encodeURIComponent(invoiceBody)}`; });
        };
        if (df) {
          df.setAttribute('aria-checked', 'false');
          df.addEventListener('click', () => {
            const selected = df.getAttribute('aria-checked') !== 'true';
            df.setAttribute('aria-checked', String(selected));
            df.setAttribute('aria-pressed', String(selected));
            dfCard.setAttribute('aria-checked', String(selected));
            updatePurchase();
          }, { signal });
        }
        updatePurchase();
      }

      const stories = [...this.querySelectorAll('.moth-story')];
      if (stories.length < 2) return;
      const sequence = this.querySelector('.moth-scroll');
      if (!sequence) return;
      const stage = sequence.querySelector('.moth-scroll-stage');
      const steps = [...sequence.querySelectorAll('button')];
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let active = -1;
      let enabled = false;
      let travel = 0;
      let top = 0;
      const activate = (index) => {
        if (index === active) return;
        active = index;
        sequence.dataset.chapter = String(index + 1);
        stories.forEach((story, i) => {
          story.classList.toggle('is-active', i === index);
          story.setAttribute('aria-hidden', String(i !== index));
          story.inert = i !== index;
        });
        steps.forEach((button, i) => {
          if (i === index) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
      };
      const update = () => {
        this.scrollFrame = null;
        if (!enabled) return;
        const progress = Math.max(0, Math.min(1, (top - sequence.getBoundingClientRect().top) / travel));
        activate(Math.min(stories.length - 1, Math.floor(progress * stories.length)));
      };
      const request = () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(update);
      };
      const layout = () => {
        sequence.classList.add('is-enhanced');
        const height = Math.ceil(stage.getBoundingClientRect().height);
        // A tall panel scrolls fully into view before pinning; it never disables the sequence.
        top = Math.min(innerWidth < 750 ? 76 : 100, innerHeight - height - 20);
        sequence.style.setProperty('--moth-scroll-top', `${top}px`);
        enabled = !reducedMotion.matches;
        sequence.classList.toggle('is-enhanced', enabled);
        if (enabled) {
          travel = Math.round(innerHeight * .8 * stories.length);
          sequence.style.height = `${height + travel}px`;
          // Keep upcoming photographs ready before their scroll transition.
          stories.forEach(story => { story.querySelector('img').loading = 'eager'; });
          active = -1;
          update();
        } else {
          sequence.style.removeProperty('height');
          stories.forEach(story => {
            story.removeAttribute('aria-hidden');
            story.inert = false;
          });
        }
      };
      steps.forEach((button, index) => button.addEventListener('click', () => {
        if (!enabled) return;
        const start = scrollY + sequence.getBoundingClientRect().top - top;
        window.scrollTo({ top: start + travel * (index + .5) / stories.length, behavior: 'smooth' });
      }, { signal }));
      window.addEventListener('scroll', request, { passive: true, signal });
      window.addEventListener('resize', layout, { passive: true, signal });
      window.addEventListener('pageshow', layout, { signal });
      window.addEventListener('load', layout, { signal });
      this.stageObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(layout);
      });
      this.stageObserver.observe(stage);
      reducedMotion.addEventListener('change', layout, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const index = stories.findIndex(story => story === event.target || story.contains(event.target));
        if (enabled && index >= 0) steps[index].click();
      }, { signal });
      layout();
      document.fonts.ready.then(() => { if (!signal.aborted) layout(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.stageObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
    }
  });
}
